'use client';

import Link from 'next/link';

import { AuthOtpForm } from '@/components/auth/otp-form';

export default function SignupPage() {
  return (
    <div className="flex min-h-[80vh] flex-col items-center justify-center px-6 py-16">
      <AuthOtpForm mode="signup" />
      <p className="mt-8 text-sm text-muted-foreground">
        Already have an account?{' '}
        <Link className="text-primary underline hover:text-primary/80" href="/auth/login">
          Log in
        </Link>
      </p>
    </div>
  );
}
